'use client';

import React from 'react';
import { X } from 'lucide-react';

interface PopupTemplateProps {
  isOpen: boolean;
  onClose?: () => void;
  closeable?: boolean;
  isTransparent?: boolean;
  children: React.ReactNode;
  maxWidth?: string;
  className?: string;
}

export default function PopupTemplate({
  isOpen,
  onClose,
  closeable = false,
  isTransparent = false,
  children,
  maxWidth = "max-w-md",
  className = ""
}: PopupTemplateProps) {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (closeable && e.target === e.currentTarget) {
      onClose?.();
    }
  };

  const handleCloseClick = () => {
    if (closeable) {
      onClose?.();
    }
  };

  // Determine background style based on isTransparent prop
  const containerBgClass = isTransparent 
    ? "bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl" 
    : "bg-[#1a1a1e] rounded-xl";

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-6"
      onClick={handleBackdropClick}
    >
      <div className={`${containerBgClass} shadow-2xl w-full max-w-[90vw] max-h-[80vh] overflow-y-auto ${maxWidth} relative ${className}`}>
        {/* Close button - only show if closeable is true */}
        {closeable && (
          <button
            onClick={handleCloseClick}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors duration-200 z-10"
          >
            <X className="h-6 w-6" />
          </button>
        )}

        {/* Content */}
        {children}
      </div>
    </div>
  );
}
